var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('nav',{staticClass:"nav-extended grey darken-4"},[_c('div',{staticClass:"nav-content"},[_c('router-link',{attrs:{"to":{name: 'Home'}}},[_c('span',{staticClass:"nav-title"},[_vm._v("WeBlog")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }